import React, { useState } from "react";
import PropTypes from "prop-types";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Button from "react-bootstrap/Button";
import InputCheckbox from "../../../forms/components/InputCheckbox";
import YesNoModal from "../../../components/YesNoModal";

const SHOW_TICLOUD_ENABLE = window?.tcbase?.consts?.cloud_enabled;
const YaraHeaderControls = ({
  canUserPublishToSdm,
  isCoreRuleset, // core rulesets cannot be saved!
  enableRuleset,
  enableRulesetTiCloud,
  enableAutoCloudRetro,
  saveEnabled,
  onEnableRulesetClick,
  onEnableRulesetTiCloudClick,
  onSaveClick,
  onSaveCloseClick
}) => {
  const [showPublishConfirm, setShowPublishConfirm] = useState(false);
  const hidePublishConfirm = () => setShowPublishConfirm(false);
  return (
    <div className={"yara-editor-header"}>
      {isCoreRuleset ? (
        <span>System Rulesets Cannot Be Saved.</span>
      ) : (
        <>
          <div className={"yara-editor-switches"}>
            <label>
              <InputCheckbox
                value={enableRuleset}
                onChange={e => onEnableRulesetClick(e.target.checked)}
                data-testid="yara_enable_ruleset_checkbox"
              />
              <span className={"yara-editor-label"}>Enable Ruleset</span>
            </label>
            {SHOW_TICLOUD_ENABLE && (
              <label>
                <InputCheckbox
                  value={enableRulesetTiCloud}
                  onChange={e => onEnableRulesetTiCloudClick(e.target.checked)}
                />
                <span className={"yara-editor-label"}>
                  Run Ruleset Continuously in Spectra Intelligence{" "}
                  {enableAutoCloudRetro
                    ? "(a YARA Retro Scan Will Automatically Start if Cloud-Enabled.)"
                    : ""}
                </span>
              </label>
            )}
          </div>

          <ButtonToolbar style={{ marginBottom: "3px" }}>
            <Button
              disabled={!saveEnabled}
              onClick={() => onSaveClick()}
              data-testid="yara_save_button"
            >
              Save
            </Button>
            <Button
              disabled={!saveEnabled}
              onClick={() => {
                if (canUserPublishToSdm) {
                  setShowPublishConfirm(true);
                  return;
                }
                onSaveCloseClick();
              }}
              data-testid="yara_save_and_publish_or_save_and_close"
            >
              {canUserPublishToSdm ? "Save & Publish" : "Save & Close"}
            </Button>
          </ButtonToolbar>
          <YesNoModal
            show={showPublishConfirm}
            title="Synchronize Ruleset"
            onClickNo={hidePublishConfirm}
            onClickYes={onSaveCloseClick}
            size="sm"
          >
            Do you want to synchronize the ruleset across other appliances?
          </YesNoModal>
        </>
      )}
    </div>
  );
};

YaraHeaderControls.propTypes = {
  canUserPublishToSdm: PropTypes.bool,
  isCoreRuleset: PropTypes.bool,
  enableRuleset: PropTypes.bool,
  enableRulesetTiCloud: PropTypes.bool,
  enableAutoCloudRetro: PropTypes.bool,
  saveEnabled: PropTypes.bool,
  onEnableRulesetClick: PropTypes.func,
  onEnableRulesetTiCloudClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  onSaveCloseClick: PropTypes.func,
  isDisabled: PropTypes.bool
};

export default YaraHeaderControls;
